import { Grid, Paper, Button, Typography, CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import MigaPan from '../../../app/orussystem/component/MigaPan';
import GraficaResultados from '../../../centraldevida/component/GeneriBascula.js/graficaResultados'
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { getResults } from '../../domain/EncuestasApi';
import { PollPanelStyle } from '../../infrastructure/PollPanelStyle';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';



const generateColors = (count) => {
    const step = 360 / count; // Paso de cambio de color
    const colors = [];

    for (let i = 0; i < count; i++) {
        const hue = (step * i) % 360; // Calcula el matiz en base al paso y el índice
        const color = `hsl(${hue}, 50%, 50%)`; // Genera un color en base al matiz, con saturación y luminosidad fijas
        colors.push(color);
    }

    return colors;
};


export const GraphicResults = (props) => {
    const location = useLocation();
    const classes = PollPanelStyle();
    const [listResults, setlistResults] = useState([]);
    const encuesta = location.state?.Encuesta || 'Sin encuesta';
    const history = useHistory();

    let { id } = useParams();
    let idPoll = id === ":id" || id === "" ? 0 : id;
    const [charts, setCharts] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const dispath = useDispatch();
    const customColors = generateColors();
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            const lista = await getResults(dispath, idPoll);

            if (lista.respuesta.length === 0) {
                setErrorMessage("No hay resultados para esta encuesta.");
            } else {
                setlistResults(lista.respuesta);
            }

            const timeout = setTimeout(() => {
                setIsLoading(false);
            }, 3000);

            // Limpiar el timeout en caso de que el componente se desmonte antes de que se complete
            return () => clearTimeout(timeout);
        };

        fetchData();
    }, [dispath, idPoll]);

    useEffect(() => {
        if (listResults.length > 0) {
            const updatedCharts = listResults.map(result => {
                if (result.pregunta === "Gracias por su tiempo, recuerde visitar la estación *EVBI* para mantener sus indicadores actualizados.") {
                    return null; // Retorna null para no renderizar nada
                }
                if (result.respuestas && result.respuestas.length > 0) {
                    const categories = result.respuestas.map(respuesta => respuesta.answer || 0);
                    const data = result.respuestas.map(respuesta => respuesta.count || 0);
                    const pregunta = result.pregunta;
                    return (
                        <Paper className={classes.tarjetas}>
                            <GraficaResultados key={result.id} categories={categories} data={data} customColors={customColors} preguntas={pregunta} />
                        </Paper>
                    );
                } else {
                    return (
                        result.pregunta !== 'Gracias por su tiempo, recuerde visitar la estación *EVBI* para mantener sus indicadores actualizados.' && (
                            <div key={result.id}>
                                <Typography>{result.pregunta ? result.pregunta === 'Gracias por su tiempo, recuerde visitar la estación *EVBI* para mantener sus indicadores actualizados.' ? "" : result.respuesta : ''}</Typography>
                                <Typography>{result.pregunta ? result.pregunta === 'Gracias por su tiempo, recuerde visitar la estación *EVBI* para mantener sus indicadores actualizados.' ? "" : '' : 'Aún no hay respuestas para esta pregunta.'}</Typography>
                            </div>
                        )
                    );
                }
            }).filter(Boolean); // Filtra los elementos nulos
            setCharts(updatedCharts);
            setIsLoading(false);
        }
    }, [listResults, classes.tarjetas, customColors]);
    const handleResultsUser = (row) => {
        let parametros = {
            Encuesta: encuesta,
          };
        history.push(`/polls/resultsUser/${id}`,parametros);
    }
    return (
        <>
            
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage={`Resultados`}
                    to="/"
                    namePage2="Encuestas"
                    to2="/Pollpanel"
                >
                    Home
                </MigaPan>
            </Grid>
            <Paper className={classes.paper} style={{ width: '100%' }} >

                <Grid item xs={12}>
                    <Grid container spacing={3}>
                    <Grid item xs={12} container justifyContent="space-between" alignItems="center">
    <Typography style={{ fontSize: '25px', fontWeight: 'bold', marginTop: '1%', marginBottom: '2%',marginLeft:'10%' }} color='primary'>Resultados {encuesta} </Typography>
    <Button
        variant="contained"
        color="primary"
        onClick={handleResultsUser}
        style={{ borderRadius: '10px' }}
    >
        Resultados por usuario
    </Button>
</Grid>
                        <Grid item xs={12} style={{ paddingLeft: '10%', paddingRight: '10%' }}>
                            {isLoading && (
                                <div style={{ marginTop: '20px', marginLeft: '30%' }}>
                                    <CircularProgress />
                                    <p>Cargando...</p>
                                </div>
                            )}
                            {!isLoading && (
                                <>
                                    {errorMessage ? (
                                        <div sty>{errorMessage}</div>
                                    ) : (
                                        <>
                                            {charts}
                                        </>
                                    )}
                                </>
                            )}
                        </Grid>
                    </Grid>

                </Grid>
            </Paper>
        </>


    )

}